import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule }
	from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { FocusMeDirective } from '../../../shared/directives/focus-me.directive';

@Component({
	selector: 'copo-dialog-batch-from-same-invoice',
	templateUrl: './dialog-batch-from-same-invoice.component.html',
	styleUrl: './dialog-batch-from-same-invoice.component.css',
	encapsulation: ViewEncapsulation.Emulated,

	imports: [TranslateModule, NgIf, MatButtonModule, FocusMeDirective, MatDialogModule]
})
export class DialogBatchFromSameInvoiceComponent {
	relatedBatchesInvoice: string | undefined;

	constructor(

		private readonly dialogRef: MatDialogRef<DialogBatchFromSameInvoiceComponent, number>,

		@Inject(MAT_DIALOG_DATA) public data: string[]
	) {
		this.relatedBatchesInvoice = data.join(', ');
	}

	evtOk() {
		this.dialogRef.close();
	}
}
